import { useQuery } from "@tanstack/react-query";
import { getCamera } from "@/api/camera";
import { CameraFilters } from "@/api/camera/types";


export function useCamera(filters?: CameraFilters) {
  return useQuery({
    queryKey: ['camera', filters],
    queryFn: () => getCamera(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}